<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "App",
  data: function() {
    return {};
  },
  computed: {},
  mounted() {},

  created() {},
  methods: {}
};
</script>

<style>
.form-title {
  background: #f0f0f0;
  padding: 10px;
  font-size: 14px;
  color: #333;
}
.el-drawer__body {
  overflow-y: auto;
  padding: 15px 10px;
}
.el-dialog__body {
  padding: 25px 20px;
}
.el-message {
  min-width: 160px;
}
/* 抽屉头部样式 */
.el-drawer__header {
  margin-bottom: 0;
}
.bg-gray {
  background-color: #f0f0f0;
}
.border-bottom {
  border-bottom: 1px solid #f0f0f0;
}
.border-right {
  border-right: 1px solid #f0f0f0;
}
.border-top {
  border-top: 1px solid #f0f0f0;
}
.border-left {
  border-left: 1px solid #f0f0f0;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.con-main {
  padding: 0 20px;
  width: 70%;
}
.con-container {
  padding: 15px;
  width: 100%;
  background-color: #fff;
  border-radius: 3px;
  margin-bottom: 20px;
}
.con-wrap {
  padding: 0 20px;
  border-bottom: 1px solid #cbcbcb;
}
.tree-dir {
  padding: 6px 0 6px 16px;
  color: #666;
  font-size: 12px;
  line-height: 1.5;
}
.text-cut {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
ul {
  list-style: none;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}
.tree-dir li {
  line-height: 25px;
  vertical-align: top;
}
.tree-dir .level2 {
  padding: 0 0 0 21px;
  background-position: -240px -25px;
}
.tree-dir .chk-wrap {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  height: 15px;
  margin: 0 26px 0 0;
  padding: 5px 0;
  line-height: 15px;
}
.tree-dir .bold {
  font-weight: 700;
}
.con-t {
  position: relative;
  z-index: 1000;
  height: 41px;
}
.con-content {
  overflow-y: auto;
  position: relative;
  margin-left: 5%;
}
.con-thd {
  height: 40px;
  padding-right: 30%;
}
.tx-r {
  text-align: right;
}
.con-tbd {
  height: 41px;
  margin-top: -40px;
  margin-left: 70%;
  line-height: 41px;
}
.tree-dir .level1 {
  background-position: -280px 0;
}
.m-t-10 {
  margin-top: 10px !important;
}
.pos-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.title-line {
  width: 4px;
  height: 14px;
  background: #11a983;
  display: inline-block;
  margin-top: -5px;
  margin-right: 10px;
  vertical-align: middle;
}
.el-form-item__label {
  padding-right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue